import { render } from "./page13.vue?vue&type=template&id=88b99506&scoped=true"
import script from "./page13.vue?vue&type=script&lang=js"
export * from "./page13.vue?vue&type=script&lang=js"

import "./page13.vue?vue&type=style&index=0&id=88b99506&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b99506"]])

export default __exports__